import { useState } from "react";
import { works } from "@/mocks/works";
import { genres } from "@/mocks/genres";
import SectionHeading from "./SectionHeading";

export default function WorksSection() {
  const [filter, setFilter] = useState("all");
  const [expanded, setExpanded] = useState<string | null>(null);

  const list = filter === "all" ? works : works.filter((w) => w.genres.includes(filter));

  return (
    <section id="works" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Selected works"
          title="代表作品赏析：十部被反复讨论的影片"
          desc="以下作品覆盖了本站全部题材方向。每张卡片都给出主题概述，展开后可查看更完整的影评要点与人性母题标注。"
        />

        <div className="mt-9 flex flex-wrap gap-2.5">
          <button
            type="button"
            onClick={() => setFilter("all")}
            aria-pressed={filter === "all"}
            className={`px-4 py-2 rounded-full font-label text-sm whitespace-nowrap border transition-colors cursor-pointer ${
              filter === "all"
                ? "bg-foreground-950 text-background-50 border-foreground-950"
                : "bg-background-50 text-foreground-700 border-background-300/70 hover:border-foreground-400"
            }`}
          >
            全部作品
          </button>
          {genres.map((g) => (
            <button
              key={g.id}
              type="button"
              onClick={() => setFilter(g.id)}
              aria-pressed={filter === g.id}
              className={`px-4 py-2 rounded-full font-label text-sm whitespace-nowrap border transition-colors cursor-pointer ${
                filter === g.id
                  ? "bg-foreground-950 text-background-50 border-foreground-950"
                  : "bg-background-50 text-foreground-700 border-background-300/70 hover:border-foreground-400"
              }`}
            >
              {g.name}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((w) => {
            const open = expanded === w.id;
            return (
              <article
                key={w.id}
                className="group flex flex-col bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <div className="relative w-full aspect-[4/5] overflow-hidden bg-background-200">
                  <img
                    src={w.cover}
                    alt={`${w.title}（${w.en}）影片封面氛围图`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 font-label text-xs tracking-wide">
                    {w.rating}
                  </span>
                  <span className="absolute top-3 right-3 px-2.5 py-1 rounded-md bg-black/45 text-background-50 font-label text-xs backdrop-blur-sm">
                    {w.region}
                  </span>
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 leading-tight">
                      {w.title}
                    </h3>
                    <p className="font-label text-xs text-background-50/75 mt-0.5">
                      {w.en} · {w.year}
                    </p>
                  </div>
                </div>

                <div className="flex flex-col flex-1 p-5">
                  <div className="flex items-center gap-2 font-label text-xs text-foreground-500">
                    <i className="ri-clapperboard-line text-sm text-accent-600"></i>
                    <span>导演：{w.director}</span>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-700">{w.summary}</p>

                  {open && (
                    <div className="mt-4 pt-4 border-t border-background-200/70 animate-fade-up">
                      <h4 className="font-label text-xs font-semibold tracking-wide text-primary-700">
                        影评要点
                      </h4>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-700">{w.review}</p>
                      <div className="mt-3 flex flex-wrap gap-2">
                        {w.themes.map((t) => (
                          <span
                            key={t}
                            className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 font-label text-xs"
                          >
                            {t}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  <button
                    type="button"
                    onClick={() => setExpanded(open ? null : w.id)}
                    aria-expanded={open}
                    className="mt-4 inline-flex items-center gap-1.5 self-start font-label text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {open ? "收起详情" : "展开影评"}
                    <i className={open ? "ri-arrow-up-s-line text-base" : "ri-arrow-down-s-line text-base"}></i>
                  </button>
                </div>
              </article>
            );
          })}
        </div>

        {list.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">该题材下暂无收录作品。</p>
        )}
      </div>
    </section>
  );
}